import { FundingGroupsGrid } from "./FundingGroups";

// Home-page Financial Aid section. Mirrors the FA landing page so visitors
// see the same intent-based grouping wherever they land.
const FinancialAid = () => (
  <section
    id="financial-aid"
    data-testid="financial-aid-section"
    className="py-16 md:py-20 bg-white"
  >
    <div className="ac-container">
      <div className="text-center max-w-3xl mx-auto mb-10">
        <div className="eyebrow">Financial Aid</div>
        <h2 className="section-heading mt-3" data-testid="financial-aid-heading">
          Funding Your Education
        </h2>
        <p className="text-[var(--ac-muted)] mt-3 text-[15px] leading-relaxed">
          Multiple financial-aid pathways — from government loans and bursaries
          to interest-free college financing. Pick the path that matches how
          you'd like to fund your studies.
        </p>
      </div>
      <FundingGroupsGrid />
    </div>
  </section>
);

export default FinancialAid;
